import type { RootState } from '../store';
import { DashboardState } from './types';

export const getDashboard = (state: RootState): DashboardState => {
  return state.dashboard || [];
};
